import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { withStyles } from '@material-ui/styles';
import { reportError } from '../../utils/reportApiError';

const style = (theme) => ({
  field: {
    marginTop: 16,
  },
  linksRow: {
    marginTop: 18,
    textAlign: 'center',
  },
  link: {
    fontWeight: 600,
    textDecoration: 'none',
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  forgotRow: {
    textAlign: 'right',
    marginTop: 6, // ok
  },
  forgotText: {
    color: theme.palette.text.secondary,
  },
  policyRow: {
    marginTop: 18,
    display: 'flex',
    alignItems: 'center',
    marginLeft: 0,
    marginRight: 0,
  },
  policyText: {
    color: theme.palette.text.secondary,
    fontSize: 13,
    lineHeight: 1.35,
  },
  actionRow: {
    marginTop: 22,
  },
  loginButton: {
    height: 48,
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    fontWeight: 700,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  progress: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
});

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkbox: true,
      data: {
        username: '',
        password: '',
      },
      validationErrors: {
        username: '',
        password: '',
      },
      showPassword: false,
      loading: false,
    };
  }

  validateForm = () => {
    //Validate every property:
    let data = this.state.data;
    Object.keys(data).forEach((key) => {
      this.validateField(key, data[key]);
    });
  };

  validateField = (key, value) => {
    let validationErrors = this.state.validationErrors;
    switch (key) {
      case 'username':
        validationErrors.username =
          value.length === 0 ? 'Inserire username' : '';
        break;
      case 'password':
        validationErrors.password =
          value.length < 8
            ? 'La password deve contenere almeno 8 caratteri'
            : '';
        break;
      default:
        break;
    }
    this.setState({
      validationErrors,
    });
  };

  handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    let validationErrors = this.state.validationErrors;
    let data = this.state.data;
    data[name] = value;
    validationErrors[name] = '';

    this.setState({
      data,
      validationErrors,
    });
  };

  handleClickShowPassword = () => {
    let flag = !this.state.showPassword;
    this.setState({
      showPassword: flag,
    });
  };

  login = () => {
    this.validateForm();
    let isFormValid =
      this.state.validationErrors.username.length === 0 &&
      this.state.validationErrors.password.length === 0;
    if (isFormValid) {
      if (this.state.checkbox === true) {
        this.setState({
          loading: true,
        });
        this.props.onLoginButtonPressed(this.state.data);
      } else {
        const message =
          'Confermare di aver letto e accettato la privacy policy e i termini di servizio.';
        reportError(message, 'Avviso');
      }
    }
  };

  handlecheck = () => {
    this.setState({ checkbox: !this.state.checkbox });
  };

  render() {
    const { classes, theme } = this.props;

    return (
      <div>
        <form autoComplete="on">
          <TextField
            label="Username"
            placeholder=""
            defaultValue={this.state.data.username}
            name="username"
            onChange={this.handleChange}
            variant="outlined"
            fullWidth
            helperText={this.state.validationErrors.username}
            error={this.state.validationErrors.username.length > 0}
          />

          <TextField
            label="Password"
            placeholder=""
            defaultValue={this.state.data.password}
            name="password"
            onChange={this.handleChange}
            variant="outlined"
            fullWidth
            type={this.state.showPassword ? 'text' : 'password'}
            className={classes.field}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title="Mostra password">
                    <IconButton
                      label="Mostra password"
                      onClick={this.handleClickShowPassword}
                    >
                      {this.state.showPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
            helperText={this.state.validationErrors.password}
            error={this.state.validationErrors.password.length > 0}
          />
        </form>

        <div className={classes.forgotRow}>
          <Typography variant="body2" className={classes.forgotText}>
            <a
              className={classes.link}
              href={
                theme.path !== ''
                  ? '/' + theme.path + '/recover_password'
                  : '/recover_password'
              }
            >
              Password dimenticata?
            </a>
          </Typography>
        </div>
        <FormControlLabel
          className={classes.policyRow}
          control={
            <Checkbox
              defaultChecked
              onChange={this.handlecheck}
              required
              value={this.state.checkbox}
              style={{
                color: theme.palette.primary.main,
              }}
            />
          }
          label={
            <div className={classes.policyText}>
              Dichiaro di aver letto ed accettato la{' '}
              <a
                href="https://bsfood.biorsaf.it/privacy_policy_bs-safe.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                privacy policy
              </a>{' '}
              e la{' '}
              <a
                href="https://biorsaf.it/cookie-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                cookie policy
              </a>
            </div>
          }
        />

        <div className={classes.actionRow}>
          <Button
            fullWidth
            variant="contained"
            onClick={this.login}
            disabled={this.state.loading}
            className={classes.loginButton}
            style={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.getContrastText(theme.palette.primary.main),
            }}
          >
            {this.state.loading ? (
              <CircularProgress size={18} className={classes.progress} />
            ) : (
              'Accedi'
            )}
          </Button>
        </div>
      </div>
    );
  }
}

LoginForm.propTypes = {
  onLoginButtonPressed: PropTypes.func.isRequired,
};

export default withStyles(style, { withTheme: true })(LoginForm);
